import React from "react"
import PropTypes from "prop-types"
import PlacesAutocomplete from "react-places-autocomplete"
import AutoCompleteField from "../../../../AutoCompleteField/AutoCompleteField"

const MAX_LENGTH = 100

/**
 * Location of the resource with place name suggestions, the same field as on the
 * create/edit form (only names, no map).
 */
const LocationField = ({ value, onChange }) => (
  <PlacesAutocomplete value={value} onChange={onChange}>
    {({ getInputProps, suggestions, loading }) => (
      <AutoCompleteField
        freeSolo
        name="filter_location"
        label="Location"
        placeholder="Enter location"
        fieldStyle="dark"
        maxLength={MAX_LENGTH}
        loading={loading}
        filterOptions={(items) => items}
        options={suggestions}
        inputValue={value}
        getOptionLabel={(option) =>
          typeof option === "string" ? option : option.description
        }
        onInputChange={(e, inputValue) => {
          const text = inputValue.substring(0, MAX_LENGTH)
          onChange(text)
          getInputProps().onChange({ target: { value: text } })
        }}
        onChange={(e, selected) => {
          if (selected && selected.description) onChange(selected.description)
        }}
      />
    )}
  </PlacesAutocomplete>
)

LocationField.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default LocationField
